import { ObjectHelper } from "./Helpers/ObjectHelper";
import { $$ } from "./JNative";
import { NAMESPACE } from "./_Namespace";

export class ObservableArray<T> extends Array<T>
{
    public static classNamespace = NAMESPACE + "ObservableArray";
    public static className = "ObservableArray";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Static

    // #region Public Methods

    public static fromArray<TSource>(array: Array<TSource>)
    {
        return new ObservableArray<TSource>(...array.map(item => ObjectHelper.cloneObject(item)));
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Public Methods

    public off(events: string, selector: string, data: any, handler: Function)
    {
        $$(this).off(events, selector, data, handler);
    }
    public on(events: string, selector: string, data: any, handler: Function)
    {
        $$(this).on(events, selector, data, handler);
    }
    public pop()
    {
        return this._callObservableMethod("pop");
    }
    public push(...items: T[])
    {
        return this._callObservableMethod("push", items);
    }
    public reverse()
    {
        return this._callObservableMethod("reverse");
    }
    public shift()
    {
        return this._callObservableMethod("shift");
    }
    public sort(compareFn?: (a: T, b: T) => number)
    {
        return this._callObservableMethod("sort", [compareFn]);
    }
    public splice(start: number, deleteCount?: number)
    {
        return this._callObservableMethod("splice", [start, deleteCount]);
    }
    public trigger(eventName: string, eventData?: any)
    {
        $$(this).trigger(eventName, eventData);
    }
    public triggerHandler(eventName: string, eventData?: any)
    {
        $$(this).triggerHandler(eventName, eventData);
    }
    public unshift(...items: T[])
    {
        return this._callObservableMethod("unshift", items);
    }

    // #endregion

    // #region Private Methods

    private _callObservableMethod(name: keyof Array<T>, args?: any[])
    {
        const
            length = this.length,
            returnValue = Array.prototype[name].apply(Array.prototype, args);

        if (length !== this.length)
            this.triggerHandler(String(name));

        return returnValue;
    }

    // #endregion

    // #endregion
}